/* TGS v2 — GoHaus-style interactions */
(function(){
  'use strict';

  /* === MOBILE NAV === */
  var mobileToggle = document.querySelector('[data-mobile-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileClose = document.querySelector('[data-mobile-close]');
  var overlay;

  function openNav(){
    if(!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden','false');
    if(mobileToggle) mobileToggle.setAttribute('aria-expanded','true');
    document.body.style.overflow = 'hidden';
    if(!overlay){
      overlay = document.createElement('div');
      overlay.className = 'mobile-overlay';
      document.body.appendChild(overlay);
    }
    requestAnimationFrame(function(){ overlay.classList.add('is-visible'); });
    overlay.addEventListener('click', closeNav);
  }

  function closeNav(){
    if(!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden','true');
    if(mobileToggle) mobileToggle.setAttribute('aria-expanded','false');
    document.body.style.overflow = '';
    if(overlay){
      overlay.classList.remove('is-visible');
      overlay.removeEventListener('click', closeNav);
      setTimeout(function(){ if(overlay){ overlay.remove(); overlay = null; } }, 300);
    }
  }

  if(mobileToggle) mobileToggle.addEventListener('click', openNav);
  if(mobileClose) mobileClose.addEventListener('click', closeNav);
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && mobileNav && mobileNav.classList.contains('is-open')) closeNav();
  });

  /* === PRODUCT CAROUSEL — scroll with arrow buttons === */
  document.querySelectorAll('[data-carousel]').forEach(function(carousel){
    var track = carousel.querySelector('[data-carousel-track]');
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    if(!track) return;

    var scrollAmount = function(){
      var card = track.querySelector('.product-card');
      return card ? card.offsetWidth + 24 : 300;
    };

    if(prev) prev.addEventListener('click', function(){
      track.scrollBy({left: -scrollAmount(), behavior:'smooth'});
    });
    if(next) next.addEventListener('click', function(){
      track.scrollBy({left: scrollAmount(), behavior:'smooth'});
    });
  });

  /* === QUANTITY BUTTONS === */
  document.addEventListener('click', function(e){
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if(minus){
      var input = minus.parentElement.querySelector('.qty-input');
      if(input){ input.value = Math.max((parseInt(input.value)||1)-1, parseInt(input.min)||0); input.dispatchEvent(new Event('change',{bubbles:true})); }
    }
    if(plus){
      var input = plus.parentElement.querySelector('.qty-input');
      if(input){ input.value = Math.min((parseInt(input.value)||1)+1, parseInt(input.max)||99); input.dispatchEvent(new Event('change',{bubbles:true})); }
    }
  });

  /* === PRODUCT GALLERY THUMBS (desktop) === */
  document.querySelectorAll('.product-gallery__thumb').forEach(function(thumb){
    thumb.addEventListener('click', function(){
      var idx = parseInt(this.getAttribute('data-thumb'));
      document.querySelectorAll('.product-gallery__thumb').forEach(function(t){ t.classList.remove('is-active'); });
      this.classList.add('is-active');
      document.querySelectorAll('.product-gallery__main-slide').forEach(function(s){ s.classList.remove('is-active'); });
      var slide = document.querySelector('.product-gallery__main-slide[data-main-slide="'+idx+'"]');
      if(slide) slide.classList.add('is-active');
    });
  });

  /* === VARIANT SWATCH SELECTOR === */
  function updateVariantSelect(form){
    var variantSelect = form.querySelector('[data-variant-select]');
    if(!variantSelect) return;

    // Collect the selected value of each option, in option order (DOM order)
    var selected = [];
    form.querySelectorAll('.product-form__option').forEach(function(group){
      var r = group.querySelector('[data-option-selector]:checked');
      if(r) selected.push(r.value);
    });

    var opts = variantSelect.options;
    for(var i = 0; i < opts.length; i++){
      var opt = opts[i];
      var ovals = [opt.getAttribute('data-opt1'), opt.getAttribute('data-opt2'), opt.getAttribute('data-opt3')]
        .filter(function(x){ return x !== null && x !== ''; });

      if(ovals.length === selected.length && ovals.every(function(v, idx){ return v === selected[idx]; })){
        variantSelect.value = opt.value;
        var submitBtn = form.querySelector('.product-form__submit');
        if(submitBtn){
          submitBtn.disabled = !!opt.disabled;
          submitBtn.textContent = opt.disabled ? 'SOLD OUT' : 'ADD TO CART';
        }
        break;
      }
    }
  }

  /* === SELLING PLAN (SUBSCRIPTION) SELECTOR === */
  document.querySelectorAll('.selling-plan-radio').forEach(function(radio){
    radio.addEventListener('change', function(){
      var group = this.closest('.selling-plan-group__options');
      if(group){
        group.querySelectorAll('.swatch').forEach(function(s){ s.classList.remove('is-active'); });
        this.closest('.swatch').classList.add('is-active');
      }
    });
  });

  document.querySelectorAll('[data-option-selector]').forEach(function(radio){
    radio.addEventListener('change', function(){
      var parent = this.closest('.product-form__values, .product-form__colors');
      if(parent){
        parent.querySelectorAll('.swatch, .color-swatch').forEach(function(s){ s.classList.remove('is-active'); });
        this.closest('.swatch, .color-swatch').classList.add('is-active');
      }

      var form = this.closest('.product-form');
      if(form) updateVariantSelect(form);

      if(this.closest('.product-form__colors')){
        var colorIndex = parseInt(this.getAttribute('data-color-image-index'));
        if(!isNaN(colorIndex)){
          document.querySelectorAll('.product-gallery__main-slide').forEach(function(s){ s.classList.remove('is-active'); });
          var mainSlide = document.querySelector('.product-gallery__main-slide[data-main-slide="'+colorIndex+'"]');
          if(mainSlide) mainSlide.classList.add('is-active');
          document.querySelectorAll('.product-gallery__thumb').forEach(function(t){ t.classList.remove('is-active'); });
          var thumb = document.querySelector('.product-gallery__thumb[data-thumb="'+colorIndex+'"]');
          if(thumb) thumb.classList.add('is-active');
          if(typeof pgGo === 'function') pgGo(colorIndex);
        }
      }
    });
  });

  /* === MOBILE PRODUCT IMAGE SLIDER === */
  var pgSlider = document.getElementById('pg-slider');
  if(pgSlider){
    var pgSlides = pgSlider.querySelectorAll('.product-gallery__slide');
    var pgDots   = pgSlider.querySelectorAll('.pg-dot');
    var pgCurrent = 0;
    var pgStartX = 0;
    var pgDragging = false;

    function pgGo(idx){
      pgSlides[pgCurrent].classList.remove('is-active');
      if(pgDots[pgCurrent]) pgDots[pgCurrent].classList.remove('is-active');
      pgCurrent = (idx + pgSlides.length) % pgSlides.length;
      pgSlides[pgCurrent].classList.add('is-active');
      if(pgDots[pgCurrent]) pgDots[pgCurrent].classList.add('is-active');
    }

    if(pgSlides.length) pgSlides[0].classList.add('is-active');

    pgDots.forEach(function(dot){
      dot.addEventListener('click', function(){
        pgGo(parseInt(this.getAttribute('data-dot')));
      });
    });

    pgSlider.addEventListener('touchstart', function(e){ pgStartX = e.touches[0].clientX; pgDragging = true; }, {passive:true});
    pgSlider.addEventListener('touchend', function(e){
      if(!pgDragging) return;
      var diff = pgStartX - e.changedTouches[0].clientX;
      if(Math.abs(diff) > 40) pgGo(pgCurrent + (diff > 0 ? 1 : -1));
      pgDragging = false;
    });

    document.querySelectorAll('[data-color-image-index]').forEach(function(radio){
      radio.addEventListener('change', function(){
        var idx = parseInt(this.getAttribute('data-color-image-index'));
        if(!isNaN(idx) && idx < pgSlides.length) pgGo(idx);
      });
    });
  }

  /* === SEARCH DRAWER === */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchDrawer = document.querySelector('[data-search-drawer]');
  var searchClose  = document.querySelector('[data-search-close]');
  var searchInput  = document.querySelector('[data-search-input]');

  function openSearch(){
    if(!searchDrawer) return;
    searchDrawer.classList.add('is-open');
    searchDrawer.setAttribute('aria-hidden','false');
    if(searchInput) setTimeout(function(){ searchInput.focus(); }, 50);
  }
  function closeSearch(){
    if(!searchDrawer) return;
    searchDrawer.classList.remove('is-open');
    searchDrawer.setAttribute('aria-hidden','true');
  }

  if(searchToggle) searchToggle.addEventListener('click', openSearch);
  if(searchClose)  searchClose.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && searchDrawer && searchDrawer.classList.contains('is-open')) closeSearch();
  });

  /* === COLLECTION FILTER SIDEBAR (mobile) === */
  var filterToggle = document.querySelector('[data-filter-toggle]');
  var sidebar = document.querySelector('[data-sidebar]');
  var filterClose = document.querySelector('[data-filter-close]');

  function openFilters(){
    if(!sidebar) return;
    sidebar.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if(!document.querySelector('.filter-overlay')){
      var ov = document.createElement('div');
      ov.className = 'mobile-overlay filter-overlay';
      document.body.appendChild(ov);
      requestAnimationFrame(function(){ ov.classList.add('is-visible'); });
      ov.addEventListener('click', closeFilters);
    }
  }
  function closeFilters(){
    if(!sidebar) return;
    sidebar.classList.remove('is-open');
    document.body.style.overflow = '';
    var ov = document.querySelector('.filter-overlay');
    if(ov){ ov.classList.remove('is-visible'); setTimeout(function(){ ov.remove(); },300); }
  }

  if(filterToggle) filterToggle.addEventListener('click', openFilters);
  if(filterClose) filterClose.addEventListener('click', closeFilters);

})();
